import { render, staticRenderFns } from "./_depositedMember.vue?vue&type=template&id=03c5be2e&scoped=true&lang=pug"
import script from "./_depositedMember.vue?vue&type=script&lang=js"
export * from "./_depositedMember.vue?vue&type=script&lang=js"
import style0 from "./_depositedMember.vue?vue&type=style&index=0&id=03c5be2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5be2e",
  null
  
)

export default component.exports